import React, { useEffect } from 'react'
import AOS from "aos";
import "aos/dist/aos.css";

const Challenge = () => {
  useEffect(() => {
    AOS.init({
      once: false,
      duration: 800,
      easing: 'ease-out'
    });
  }, []);

  return (
    <section className="lg:py-16 lg:px-12 px-4 py-12 bg-bgDefault text-white overflow-x-hidden">
      <div className="container mx-auto w-full max-w-full max-w-screen-xl overflow-hidden">
        {/* Header */}


        {/* Content Container */}
        <div className="lg:px-[168px]">
          {/* Description */}
          <h2
            className="text-3xl lg:text-4xl font-bold tracking-tight mb-6 lg:mb-8"
            // data-aos="fade-down"
          >
            The Challenge
          </h2>

          <p
            className="text-[#9E9E9E] text-base lg:text-lg leading-relaxed mb-6"
            // data-aos="fade-up"
            // data-aos-delay="100"
          >
            A leading Australian document management provider serving 2,500+ customers across Asia-Pacific and Europe
            faced critical challenges in scaling their legacy document management infrastructure. Their existing systems
            struggled with growing document volumes, lacked advanced search capabilities for image-based documents, and
            couldn't efficiently integrate with modern enterprise platforms like SAP, ADP, and OpenText. Manual document
            processing workflows were creating bottlenecks, security vulnerabilities were increasing, and customer
            satisfaction was declining due to slow search performance and limited workflow automation.
          </p>

          <h4
            className="text-xl font-semibold text-white mb-3"
            // data-aos="fade-right"
            // data-aos-delay="200"
          >
            Key Challenges:
          </h4>
          <ul className="text-[#9E9E9E] text-base lg:text-lg leading-relaxed mb-8 lg:mb-12 list-disc pl-5 space-y-2">
            <li >Scalability crisis: existing infrastructure couldn't handle projected growth to 100+ million documents</li>
            <li >Image-based documents were non-searchable, making content discovery nearly impossible</li>
            <li >Manual document approval workflows consuming 40%+ more time than industry standards</li>
            <li >Complex integration requirements with enterprise systems (SAP, ADP, OpenText) across diverse industries</li>
            <li >Security vulnerabilities leading to increasing unauthorized access incidents</li>
            <li>Need for modular architecture balancing simplicity with future scalability</li>
            <li>Requirement for automated CI/CD pipelines with Jenkins for reliable deployments</li>
            <li >Full-text search across millions of documents needed to complete in under 1 second</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Challenge
